import AnalogInstrument from "@/pages/portal/tools/AnalogInstrument";

export default function SRS() {
  return <AnalogInstrument kind="srs" />;
}
